import PartnerLogo from './PartnerLogo';
export default {
  components: {
    PartnerLogo
  }
};